module.exports = "img/flags/NG.c17ec02.png";